/**
 * ssom.js
 */
 export const SSOM = (function () {

    var init =  function () {   
        
        $('.subscriber-dropdown').on('click', (e) => {
            $('.susbscriber-list').removeClass('d-none');
        });

        $('.send-invite').on('click', (e) => {debugger;
            e.preventDefault();
            $('#subscribers-invites').modal({
                backdrop: 'static',
                keyboard: false,
                show: true
            });
        });

        $('.myds-suspend').on('click', (e) => {
            e.preventDefault();
            $('#suspend').modal({
                backdrop: 'static',
                keyboard: false,
                show: true
            });
        });

        $('.myds-open-roles').on('click', (e) => {
            $('.myds-macm-default-roles').toggleClass('d-none');
        });

        $('.myds-open-role-form').on('click', (e) => {
            $('#create-role').toggleClass('d-none');
        });

        $('.myds-invite-member').on('click', (e) => {
            e.preventDefault();
            $('#members-invites').modal({
                backdrop: 'static',
                keyboard: false,
                show: true
            });
        });

        // Populate Member Roles 
        $('.myds-edit-member').on('click', (e) => {
          e.preventDefault();

          console.log(e)
          $('#myds-edit-member-modal').modal({
              backdrop: 'static',
              keyboard: false,
              show: true
          });
        });

        // Populate Member Roles 
        $('#myds-ssom-save-member-roles').on('click', (e) => {
          editMemberRoles(e);
        });

    }

    function editMemberRoles(e)
    {
      // Get all checked toggles
      var checkedRoles = $('.myds-role:checked').map(function() {
        return this.value;
      }).get();
      console.log($(`#myds-ssom-save-member-roles`).data('mydexid'))
      var mydexid = $(`#myds-ssom-save-member-roles`).data('mydexid');

      var promises = [];

      promises.push($.ajax({
        url: `members/${mydexid}/roles`,
        type: 'PUT',
        data: {
            roles: checkedRoles
        },
        headers: {
          'x-csrf-token': Util.getCSRF() 
        }
      }));

      // Get the name from the UI
      var name = $('#myds-member-name').val();

      if(name)
      {
        promises.push($.ajax({
          url: `members/${mydexid}`,
          type: 'PUT',
          data: {
              name: name
          },
          headers: {
            'x-csrf-token': Util.getCSRF() 
          }
        }));
      }

      // Show an alert on success and fail
      Promise.all(promises).then((values) => {
        Util.toggleAlert('#myds-alert-modal', "Success, member roles updated", 'alert-success', 5000);
      })
      .catch((error) => {
        Util.toggleAlert('#myds-alert-modal', "Sorry, there was an error updating the member roles.", 'alert-danger', 5000);
      });

      // Refresh the bootstrap table
      $('#ssom-members-roles-table').bootstrapTable('refreshOptions', {
        url: `members/roles`,
        method : "GET"
      });
    }


    function poppulateMemberRolesTable(element){

      // Poppulate the MydexID on the save changes button for later
      var mydexid = element.dataset.mydexid;
      $(`#myds-ssom-save-member-roles`).data('mydexid',mydexid);
      
      var promise = $.ajax({
        url: `members/${mydexid}/roles`,
        type: 'get'
      });
      
      promise.done(function (response) {
        // Poppualte the name
        $(`#myds-member-name`).val( );
        $(`#myds-member-name`).val( response.member.details.name );
        // Populate the toggles
        $(`.myds-role`).prop( "checked", false );
        response.member.roles.forEach(role => {
            $(`#myds-role-${role.id}`).prop( "checked", true );
        });
      })      
    }

    var formatters = {
      roleEditFormatter : function(value,row,index,field){
        return `<button onclick="SSOM.poppulateMemberRolesTable(this)" data-mydexid="${row['mydexid']}" id='myds-edit-member' class='text-primary btn m-0 p-0 ml-2 mr-3 myds-edit-member' data-toggle='modal' data-target='#myds-edit-member-modal'> <i class='fas fa-edit'></i> </button>`;
      },
      blankNameFormatter : function(value,row,index,field){
        if(!value){
          return `<em>Click Edit to Add</em>`;
        }
        return value
      }
    }

    return {
      init: init,
      formatters: formatters,
      poppulateMemberRolesTable: poppulateMemberRolesTable,
      editMemberRoles:editMemberRoles
    }
  
}());
  